
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.8725 7.07679L11.2429 9.5426L11.8639 13.0253C11.8909 13.1776 11.8259 13.3315 11.6959 13.4224C11.6224 13.474 11.5351 13.5 11.4477 13.5C11.3806 13.5 11.313 13.4846 11.2514 13.4533L8 11.809L4.74904 13.4529C4.6072 13.5252 4.43454 13.5134 4.30452 13.422C4.1745 13.3311 4.10949 13.1772 4.13651 13.0249L4.75749 9.5422L2.12751 7.07679C2.01268 6.96877 1.97089 6.80715 2.02071 6.66055C2.07052 6.51395 2.20265 6.40633 2.3618 6.384L5.99607 5.87638L7.62133 2.70802C7.7636 2.43066 8.2364 2.43066 8.37867 2.70802L10.0039 5.87638L13.6382 6.384C13.7973 6.40633 13.9295 6.51354 13.9793 6.66055C14.0291 6.80755 13.9873 6.96837 13.8725 7.07679Z","fill":"#10001F"}})])
          )
        }
      }
    